import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { NAV } from "../data/site";
import { MobileMenu } from "./MobileMenu";
import { lenisRef } from "../lib/smooth";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  useEffect(() => {
    if (open) lenisRef.current?.stop();
    else lenisRef.current?.start();
    document.body.style.overflow = open ? "hidden" : "";
  }, [open]);

  return (
    <>
      <header
        className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,padding] duration-500 ${
          scrolled ? "border-b border-ink/10 bg-paper/80 py-3 backdrop-blur-xl" : "border-b border-transparent py-5"
        }`}
        data-testid="site-header"
      >
        <div className="flex items-center justify-between px-5 sm:px-10 lg:px-16">
          <Link to="/" className="flex items-center gap-3" aria-label="B Digital Studio — Home" data-testid="header-logo">
            <img src="/img/mark-dark.png" alt="" width="42" height="40" className="h-9 w-auto md:h-10" />
            <span className="hidden text-[11px] font-medium uppercase tracking-[0.32em] sm:inline">B Digital Studio</span>
          </Link>
          <nav aria-label="Navigazione principale" className="hidden items-center gap-10 md:flex">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} className="link-u pb-0.5 text-sm tracking-[0.04em]" data-testid={`nav-${n.label.toLowerCase()}`}>
                {n.label}
              </NavLink>
            ))}
            <Link to="/contatti" className="bg-ink px-5 py-2.5 text-xs font-medium uppercase tracking-[0.16em] text-paper transition-colors duration-500 hover:bg-teal" data-testid="header-cta">
              Parliamo della tua attività
            </Link>
          </nav>
          <button
            type="button"
            onClick={() => setOpen(true)}
            className="flex items-center gap-3 py-2 text-xs font-medium uppercase tracking-[0.2em] md:hidden"
            aria-expanded={open}
            aria-controls="mobile-menu"
            data-testid="mobile-menu-open"
          >
            Menu
            <span className="flex w-6 flex-col gap-1.5" aria-hidden="true"><span className="h-px bg-ink" /><span className="h-px w-4 bg-ink" /></span>
          </button>
        </div>
      </header>
      <AnimatePresence>{open && <MobileMenu onClose={() => setOpen(false)} />}</AnimatePresence>
    </>
  );
};
